import { useMemo } from "react";

// Modify this function to return an array instead of an object
const filterSectionsByPriceMode = (sections, priceMode) => {
  const filteredSectionsArray = [];

  if (sections) {
    Object.keys(sections).forEach((key) => {
      const section = sections[key];

      // Filter out sections that do not include the priceMode

      if (section.price_modes?.includes(priceMode)) {
        // Recursively filter sub_sections and options
        const filteredSection = {
          ...section,
          sub_sections: section.sub_sections
            ? filterSectionsByPriceMode(section.sub_sections, priceMode)
            : [],
          options: section.options
            ? filterSectionsByPriceMode(section.options, priceMode)
            : [],
        };

        // Add the filtered section to the array
        filteredSectionsArray.push(filteredSection);
      }
    });
  }

  return filteredSectionsArray;
};

const useFilteredSections = (data, priceMode) => {
  return useMemo(() => {
    const filteredSections = filterSectionsByPriceMode(data, priceMode);

    return filteredSections; // Ensure sections is an array now
  }, [data, priceMode]);
};

export default useFilteredSections;
